import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { APP_SETTINGS, ToastConfigService } from '@services';
import { SubscriptionLike as ISubscription } from 'rxjs';
import { AuthService } from '../../../core/services/auth/auth.service';
import { UtilityService } from '../../../core/services/utility/utility.service';
import { CmsNavbarService } from '../../cms-navbar/cms-navbar.service';
import { ModelMapService } from '../../model-map/model-map.service';
import { UserProfileService } from '../../user-profile/user-profile.service';
import { VideosService } from '../../videos/videos.service';
import { AdminService } from '../admin.service';
// import { OnDestroy } from '@angular/core/src/metadata/lifecycle_hooks';
import { NgForm, FormsModule } from '@angular/forms';
import { IDropdownSettings, NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { BMWListData } from '../../../core/models/bmwListData';
import { FindAllNoiseCatalogNumberListRequest } from '../../../core/models/findAllNoiseCatalogNumberListRequest';
import { FindAllNoiseCatalogNumberListResponse } from '../../../core/models/findAllNoiseCatalogNumberListResponse';
import { FindOneNoiseCatalogNumberRequest } from '../../../core/models/findOneNoiseCatalogNumberRequest';
import { FindOneNoiseCatalogNumberResponse } from '../../../core/models/findOneNoiseCatalogNumberResponse';
import { MINIListData } from '../../../core/models/miniListData';
import { MOTORRADListData } from '../../../core/models/motorradListData';
import { NoiseCatalogData } from '../../../core/models/noiseCatalogData';
import { NoiseCatalogNumbersList } from '../../../core/models/noiseCatalogNumbersList';
import { NoiseCatalogParamsRefDataResponse } from '../../../core/models/noiseCatalogParamsRefDataResponse';
import { ResultStatus } from '../../../core/models/resultStatus';
import { ROLLSROYCEListData } from '../../../core/models/rollsRoyceListdata';
import { UpdateExistingNoiseCatalogRequest } from '../../../core/models/updateExistingNoiseCatalogRequest';
import { AnalyticsService } from '../../../core/services/analytics/analytics.service';
import { DialogService } from '../../../core/services/dialog/dialog.service';
import { SpinnerService } from '../../../core/services/spinner/spinner.service';
import { NoiseCatalogService } from '../../noise-catalog/noise-catalog.service';
import { NgIf, NgFor, NgStyle } from '@angular/common';
import { SelectRequiredValidatorDirective } from '../../../shared/directives/select-required-validator.directive';

declare var $: any;
@Component({
    selector: 'app-edit-bulletin-for-noise-catalog-component',
    templateUrl: './edit-bulletin-for-noise-catalog-component.component.html',
    styleUrls: ['./edit-bulletin-for-noise-catalog-component.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        FormsModule,
        NgIf,
        SelectRequiredValidatorDirective,
        NgFor,
        NgStyle,
        NgMultiSelectDropDownModule,
    ],
})
export class EditBulletinForNoiseCatalogComponentComponent implements OnInit, OnDestroy {

  public bulletinType = '';
  public actionType = '';
  private subscriptions: ISubscription[] = [];
  public makeList;
  public inputMake;
  public inputDate: string;
  public selDate;
  public tkrCode = '';
  public isTakataRecall = false;
  public documentNumber = '';
  public bulletinNumber = '';
  public textareaContent = '';
  public relatedSIBs: string[] = [];
  public setDateFlag: boolean = false;

  //public reactivateOrDeactivate: any;

  public reactivate = false;
  public deactivate = false;
  public isDocActive = false;
  public makeNameForApi: string;
  //  public listMakeName: ParamListItem[];

  public inputSeries = '';
  public inputModel = '';
  public inputEngine = '';

  public inputSproadicPermanent: any;
  public inputArea = '';
  public inputComponent = '';
  public inputDrivingCondition = '';
  public inputWeatherCondition = '';
  public inputKindOfNoise = '';

  public inputChannel: any;

  public noiseCatalogNumber: any;

  public channelsList = [];
  public sproadicPermanentList = [];

  public seriesList: any[];
  public seriesFilterList: any[];


  public areaList: string[];
  public areaFilterList: string[];
  public componentList: any[];
  public componentFilterList: any[];
  public drivingConditionList: any[];
  public drivingConditionFilterList: any[];
  public weatherConditionList: any[];
  public weatherConditionFilterList: any[];
  public kindOfNoiseList: any[];
  public kindOfNoiseFilterList: any[];
  public noiseCatalogParamsRefDataResponse: NoiseCatalogParamsRefDataResponse;

  findAllNoiseCatalogNumberListRequest?= new FindAllNoiseCatalogNumberListRequest();
  findAllNoiseCatalogNumberListResponse?= new FindAllNoiseCatalogNumberListResponse();

  findOneNoiseCatalogNumberRequest?= new FindOneNoiseCatalogNumberRequest();
  findOneNoiseCatalogNumberResponse?= new FindOneNoiseCatalogNumberResponse();


  updateExistingNoiseCatalogRequest?= new UpdateExistingNoiseCatalogRequest();
  UpdateExistingNoiseCatalogResponse?= new UpdateExistingNoiseCatalogRequest();

  public documentNumbersList: any[];
  public NoiseCatalogNumbersList: NoiseCatalogNumbersList[];
  public noiseCatalogData: NoiseCatalogData;
  public obdCategories: any[];
  public docId: number;

  private userEmail: string;

  public errorMessage = '';
  public errorMessageSIB = '';
  public showAllFields: boolean = false;

  public uploadedFileName = 'No File Selected';
  public vimeoID = '';
  public uploadedFile = null;

  public pageTitle: string;

  public allObdData: any[];
  public documentOBDTitle;

  public newUploadFlag: boolean = false;
  public showAllOptionsOBD: boolean = false;
  public showAllOptionsTool: boolean = false;

  public isMotorradAdmin: boolean = false;
  public isRollsRoyceAdmin: boolean = false;
  public isAdmin: boolean = false;
  public isMotorrad: boolean = false;
  public isRollsRoyce: boolean = false;
  public showTakata: boolean = false;
  dropdownESeriesList = [];
  dropdownAreaList = [];
  dropdownComponentList = [];
  dropdownDrivingConditionList = [];
  dropdownKindOfNoiseList = [];
  dropdownWeatherConditionList = [];
  selectedItems = [];
  BMW?: BMWListData;
  MINI?: MINIListData;
  MOTORRAD?: MOTORRADListData;
  ROLLSROYCE?: ROLLSROYCEListData;
  prevMake?: string;
  currentMake?: string;
  makeSelected?: string;
  //dropdownSettings = {};
  // public sproadicPermanentList = [];
  mouseoverLogin;

  dropdownSettingsSeries: IDropdownSettings = {
    singleSelection: false,
    idField: 'id',
    textField: 'seriesName',
    // selectAllText: 'Select All',
    // unSelectAllText: 'UnSelect All',
    itemsShowLimit: 0,
    limitSelection: -1,
    allowSearchFilter: true,
    enableCheckAll: false,
    clearSearchFilter: true,
    noDataAvailablePlaceholderText: 'No data available',
    searchPlaceholderText: 'Search',
    closeDropDownOnSelection: true,
    showSelectedItemsAtTop: false,
    defaultOpen: false
  };

  dropdownSettingsArea: IDropdownSettings = {
    singleSelection: false,
    idField: 'id',
    textField: 'signalName',
    // selectAllText: 'Select All',
    // unSelectAllText: 'UnSelect All',
    itemsShowLimit: 0,
    limitSelection: -1,
    allowSearchFilter: true,
    enableCheckAll: false,
    clearSearchFilter: true,
    noDataAvailablePlaceholderText: 'No data available',
    searchPlaceholderText: 'Search',
    closeDropDownOnSelection: true,
    showSelectedItemsAtTop: false,
    defaultOpen: false
  };

  dropdownSettings: IDropdownSettings = {
    singleSelection: false,
    // idField: 'value',
    // textField: 'viewValue',
    // selectAllText: 'Select All',
    // unSelectAllText: 'UnSelect All',
    itemsShowLimit: 0,
    limitSelection: -1,
    allowSearchFilter: true,
    enableCheckAll: false,
    clearSearchFilter: true,
    noDataAvailablePlaceholderText: 'No data available',
    searchPlaceholderText: 'Search',
    closeDropDownOnSelection: true,
    showSelectedItemsAtTop: false,
    defaultOpen: false,

  };

  constructor(
    private cmsNavbarService: CmsNavbarService,
    private toastService: ToastConfigService,
    private adminService: AdminService,
    private modelMapService: ModelMapService,
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
    private userProfileService: UserProfileService,
    private changeDetectorRef: ChangeDetectorRef,
    private utilityService: UtilityService,
    private spinnerService: SpinnerService,
    private videoService: VideosService,
    private noiseCatalogService: NoiseCatalogService,
    private dialogService: DialogService,
    private analyticsService: AnalyticsService
    //private cmsNavbarService: CmsNavbarService,

  ) {  }

  getPageTitle(): string {

    //this.pageTitle = (this.actionType.charAt(0).toUpperCase() + this.actionType.slice(1) + " " + this.bulletinType.charAt(0).toUpperCase() + this.bulletinType.slice(1));
    this.pageTitle = (this.actionType.charAt(0).toUpperCase() + this.actionType.slice(1) + " " + "Noise Catalog");
    return this.pageTitle;
  }

  public onDropDownClose(item: any): void {
    // FIXME method beign used with no implementation
  }

  ngOnInit() {
    this.inputSproadicPermanent = "undefined";
    this.inputChannel = "undefined";
    this.noiseCatalogNumber = "undefined";
    this.makeSelected = "BMW";
    this.prevMake = "undefined";
    this.errorMessageSIB = '';
    // this.listMakeName = [{ value: 1, viewValue: 'BMW' },
    // { value: 2, viewValue: 'MINI' }, { value: 3, viewValue: 'MOTORRAD' }];
    $(document).ready(function () {
      $('[data-toggle="tooltip"]').tooltip();
    });

    // $(function () {
    //   $('[data-toggle="tooltip"]').tooltip()
    // })

    if (APP_SETTINGS.isMotorradAdmin === 'true') {
      this.isMotorradAdmin = true;
    }
    if (APP_SETTINGS.isRollsRoyceAdmin === 'true') {
      this.isRollsRoyceAdmin = true;
    }
    if (APP_SETTINGS.isAdmin === 'true') {
      this.isAdmin = true;
    }
    if (APP_SETTINGS.isMOTORRAD === 'true') {
      this.isMotorrad = true;
    }
    if (APP_SETTINGS.isRollsRoyce === 'true') {
      this.isRollsRoyce = true;
    }
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };

    this.router.events.subscribe((evt) => {
      if (evt instanceof NavigationEnd) {
        // trick the Router into believing it's last link wasn't previously loaded
        this.router.navigated = false;
        // if you need to scroll back to top, here is the right place
        window.scrollTo(0, 0);
      }
    });

    this.pageTitle = '';

    this.userProfileService.getUsersInfoById(this.authService.getUserName()).subscribe(userData => {
      this.userEmail = userData['email'];
    });

    // this.userEmail = 'Chad.Pinson@partner.bmwgroup.com';
    this.documentNumbersList = [];
    this.seriesList = [];

    this.resetFields();
    this.getPageTitle();
    this.bulletinType = this.route.snapshot.paramMap.get('bulletinType');
    this.actionType = this.route.snapshot.paramMap.get('actionType');

    this.areaList = [];
    this.componentList = [];
    this.componentFilterList = [];
    this.drivingConditionList = [];
    this.weatherConditionList = [];
    this.kindOfNoiseList = [];

    this.subscriptions.push(this.cmsNavbarService.getAllMakeList().subscribe(data => {
      if (this.isMotorradAdmin === true) {
        this.makeList = data.filter(make => (make['makeName'] === 'MOTORRAD'));
      } else if (this.isRollsRoyceAdmin === true) {
        this.makeList = data.filter(make => (make['makeName'] === 'ROLLSROYCE'));
      } else {
        this.makeList = data.filter(make => (make['makeName'] === 'BMW' || make['makeName'] === 'MINI' || make['makeName'] === 'MOTORRAD' || make['makeName'] === 'ROLLSROYCE'));
      }
    }));

    this.subscriptions.push(this.cmsNavbarService.getMainGroupsList().subscribe(data => {
      this.channelsList = data;
    }));

    this.subscriptions.push(this.modelMapService.getAllSeries().subscribe(data => {
      this.seriesList = data;
      this.dropdownESeriesList = this.seriesList;
    }));

    this.subscriptions.push(this.noiseCatalogService.findAllNoiseCatalogParamsRefData().subscribe(
      (data: NoiseCatalogParamsRefDataResponse) => {
        this.noiseCatalogParamsRefDataResponse = data;
      },
      (err: ResultStatus) => {
        console.error('Error searching all noise catalog', err);
      },
      () => this.populateNoiseParamList()
    ));

    this.setRandomDocNumber();
  }

  findAllNoiseCatalogNumberList(makeName) {
    this.spinnerService.show("bmwSpinner");
    this.findAllNoiseCatalogNumberListRequest.makeName = makeName;
    this.subscriptions.push(this.noiseCatalogService.findAllNoiseCatalogNumberList(this.findAllNoiseCatalogNumberListRequest).subscribe(
      (data: FindAllNoiseCatalogNumberListResponse) => {
        this.findAllNoiseCatalogNumberListResponse = data;
        this.spinnerService.hide("bmwSpinner");
      },
      (err: ResultStatus) => {
        console.error('Error retrieving all noise catalog number list', err);
        this.spinnerService.hide("bmwSpinner");
      },
      () => this.populateAllNoiseCatalogNumberList()
    ));
  }

  populateAllNoiseCatalogNumberList() {
    this.NoiseCatalogNumbersList = this.findAllNoiseCatalogNumberListResponse.noiseCatalogNumbersList;
  }

  populateNoiseParamList() {
    if (this.noiseCatalogParamsRefDataResponse != null && this.noiseCatalogParamsRefDataResponse.status.statusCode === 'SUCCESS') {
      this.BMW = this.noiseCatalogParamsRefDataResponse.noiseCatalogDataParams.BMW;
      this.MINI = this.noiseCatalogParamsRefDataResponse.noiseCatalogDataParams.MINI;
      this.MOTORRAD = this.noiseCatalogParamsRefDataResponse.noiseCatalogDataParams.MOTORRAD;
      this.ROLLSROYCE = this.noiseCatalogParamsRefDataResponse.noiseCatalogDataParams.ROLLSROYCE;
      if (this.makeSelected === 'BMW') {
        this.populateNoiseParamListByMake(this.makeSelected);
        this.findAllNoiseCatalogNumberList(this.makeSelected);
      }
    }
  }

  populateOneNoiseCatalogNumber() {

    this.noiseCatalogData = this.findOneNoiseCatalogNumberResponse.noiseCatalogData;
    this.inputChannel = this.channelsList.find(channel => channel['mainGroupName'] === this.noiseCatalogData.mainGroup.mainGroupName);
    console.log('list',this.sproadicPermanentList,this.sproadicPermanentList.length);
    this.inputSproadicPermanent = this.sproadicPermanentList.find(sproadicPermanent => sproadicPermanent === this.noiseCatalogData.sporadicOrPermanent);
    this.vimeoID = this.noiseCatalogData.noiseCatalogVimeoId;
    this.textareaContent = this.noiseCatalogData.noiseCatalogTitle;
    this.isDocActive = this.noiseCatalogData.isActive;
    this.relatedSIBs = this.noiseCatalogData.bulletinDisplayNumber;
    //const selectedSeries = filterSeriesArray(this.seriesList, this.noiseCatalogData.series);
    this.seriesFilterList = filterSeriesArray(this.seriesList, this.noiseCatalogData.series);
    this.areaFilterList = this.noiseCatalogData.noiseCatalogAreas;
    this.componentFilterList = this.noiseCatalogData.noiseCatalogComponents;
    this.drivingConditionFilterList = this.noiseCatalogData.noiseDrivingConditions;
    this.weatherConditionFilterList = this.noiseCatalogData.noiseWeatherConditions;
    this.kindOfNoiseFilterList = this.noiseCatalogData.noiseNoiseTypes;
    setTimeout(() => {
      this.selDate = this.noiseCatalogData.releaseDate;
      this.inputDate = this.noiseCatalogData.releaseDate;
    }, 50)
    this.spinnerService.hide("bmwSpinner");
  }
  // functions for edit
  getNoiseCatalogData(noiseCatalogNumber, makeName) {
	console.log('inside getNoiseCatalogData',makeName,noiseCatalogNumber)
    if (makeName === null || noiseCatalogNumber === null)
      return;
    this.spinnerService.show("bmwSpinner");
    this.selDate = '';
    this.inputDate = '';
    this.findOneNoiseCatalogNumberRequest.makeName = makeName;
    this.findOneNoiseCatalogNumberRequest.docNumber = noiseCatalogNumber;
    console.log('details',this.findOneNoiseCatalogNumberRequest);
    this.subscriptions.push(this.noiseCatalogService.findOneNoiseCatalogNumber(this.findOneNoiseCatalogNumberRequest).subscribe(
      (data: FindOneNoiseCatalogNumberResponse) => {
	console.log('success ',data)
	
        this.findOneNoiseCatalogNumberResponse = data;
        this.showAllFields = true;
        this.spinnerService.hide("bmwSpinner");
      },
      (err: ResultStatus) => {
        this.spinnerService.hide("bmwSpinner");
        //this.errorMessage = err.errorDetails;
        console.error('Error retrieving noise catalog number', err);
        //this.errorMessage = error.error.message;
        if (err !== null && err.statusCode === 'FAILURE') {
          this.errorMessage = err.errorDetails;
        }
        console.error('Erro retrieving noise catalog number', err);
      },
      ()=> this.populateOneNoiseCatalogNumber()
    ));
  }

  onMakeSelectionChanged(event) {

    if (this.makeSelected != "undefined" && this.prevMake != event) {
      if (this.dialogService.confirm('Changing the Make will reset the form entries, all entries will be lost. \n Do you want to continue? ')['value'] === true) {
        this.makeSelected = event;
        this.prevMake = event;
        this.changeMaingroupList(this.makeSelected);
        this.populateNoiseParamListByMake(this.makeSelected);
        this.showAllFields = false;
      }
      else {
        this.makeSelected = this.prevMake;
      }
    }
    if (this.makeSelected == "undefined" && event != "undefined") {
      this.makeSelected = event;
      this.prevMake = event;
      this.changeMaingroupList(this.makeSelected);
      this.populateNoiseParamListByMake(this.makeSelected);
    }
    //this.getAllVideoNumbers(event);
    this.findAllNoiseCatalogNumberList(event);
    return this.prevMake;
  }
  changeMaingroupList(makeNameCurrent){
    this.subscriptions.push(this.cmsNavbarService.getMainGroupsListbyMakeName(makeNameCurrent).subscribe(data => {
      this.channelsList = data;
    }));
  }

  populateNoiseParamListByMake(makeNameCurrent) {

    this.resetFields();
    if (makeNameCurrent === 'BMW') {
      this.inputMake = 'BMW';
      /*this.areaList = this.BMW.area;
      this.dropdownAreaList = this.areaList;
      this.componentList = this.BMW.component;
      this.dropdownComponentList = this.componentList;
      this.drivingConditionList = this.BMW.driveConditions;
      this.dropdownDrivingConditionList = this.drivingConditionList;
      this.weatherConditionList = this.BMW.weatherConditions;
      this.dropdownWeatherConditionList = this.weatherConditionList;
      this.kindOfNoiseList = this.BMW.kindOfNoise;
      this.dropdownKindOfNoiseList = this.kindOfNoiseList;
      this.sproadicPermanentList = this.BMW.sporadicOrPermanent;*/
    }
    else if (makeNameCurrent === 'MINI') {
      this.inputMake = 'MINI';
      /*this.areaList = this.MINI.area;
      this.dropdownAreaList = this.areaList;
      this.componentList = this.MINI.component;
      this.dropdownComponentList = this.componentList;
      this.drivingConditionList = this.MINI.driveConditions;
      this.dropdownDrivingConditionList = this.drivingConditionList;
      this.weatherConditionList = this.MINI.weatherConditions;
      this.dropdownWeatherConditionList = this.weatherConditionList;
      this.kindOfNoiseList = this.MINI.kindOfNoise;
      this.dropdownKindOfNoiseList = this.kindOfNoiseList;
      this.sproadicPermanentList = this.MINI.sporadicOrPermanent;*/
    }
    else if (makeNameCurrent === 'MOTORRAD') {
      this.inputMake = 'MOTORRAD';
      /*this.areaList = this.MOTORRAD.area;
      this.dropdownAreaList = this.areaList;
      this.componentList = this.MOTORRAD.component;
      this.dropdownComponentList = this.componentList;
      this.drivingConditionList = this.MOTORRAD.driveConditions;
      this.dropdownDrivingConditionList = this.drivingConditionList;
      this.weatherConditionList = this.MOTORRAD.weatherConditions;
      this.dropdownWeatherConditionList = this.weatherConditionList;
      this.kindOfNoiseList = this.MOTORRAD.kindOfNoise;
      this.dropdownKindOfNoiseList = this.kindOfNoiseList;
      this.sproadicPermanentList = this.MOTORRAD.sporadicOrPermanent;*/
    }
    else if (makeNameCurrent === 'ROLLSROYCE') {
      this.inputMake = 'ROLLSROYCE';
      /*this.areaList = this.ROLLSROYCE.area;
      this.dropdownAreaList = this.areaList;
      this.componentList = this.ROLLSROYCE.component;
      this.dropdownComponentList = this.componentList;
      this.drivingConditionList = this.ROLLSROYCE.driveConditions;
      this.dropdownDrivingConditionList = this.drivingConditionList;
      this.weatherConditionList = this.ROLLSROYCE.weatherConditions;
      this.dropdownWeatherConditionList = this.weatherConditionList;
      this.kindOfNoiseList = this.ROLLSROYCE.kindOfNoise;
      this.dropdownKindOfNoiseList = this.kindOfNoiseList;
      this.sproadicPermanentList = this.ROLLSROYCE.sporadicOrPermanent;*/
    }
  }

  resetFields() {
    this.inputMake = null;
    this.seriesFilterList = [];
    this.relatedSIBs = [];
    this.uploadedFile = this.inputDate = '';
    this.uploadedFileName = 'No File Selected';
    this.vimeoID = '';
    this.bulletinNumber = this.documentNumber = this.textareaContent = this.tkrCode = '';
    this.isTakataRecall = false;
    this.newUploadFlag = false;
    this.documentNumber = null;
    this.makeNameForApi = undefined;

    this.areaList = [];
    this.dropdownAreaList = [];
    this.areaFilterList = [];

    this.componentList = [];
    this.dropdownComponentList = [];
    this.componentFilterList = [];

    this.drivingConditionList = [];
    this.dropdownDrivingConditionList = [];
    this.drivingConditionFilterList = [];

    this.weatherConditionList = [];
    this.dropdownWeatherConditionList = [];
    this.weatherConditionFilterList = [];

    this.kindOfNoiseList = [];
    this.dropdownKindOfNoiseList = [];
    this.kindOfNoiseFilterList = [];

    this.sproadicPermanentList = [];
    this.inputSproadicPermanent = "undefined";
    this.inputChannel = "undefined";
    this.noiseCatalogNumber = "undefined";
  }

  addToSelection(listType: string, listItem: string | object) {
    listItem = listItem !== null && typeof listItem === 'object' ? listItem['engineName'] : listItem;
    if (listItem) {
      switch (listType) {
        case 'sib':
          this.bulletinNumber = '';
          this.addNewBulletin(this.makeSelected, listItem);
          break;
      }
    }
  }

  addNewBulletin(makeSelected, bulletinNumber) {
    this.errorMessageSIB = '';
    if (bulletinNumber) {
      const bulletinId = bulletinNumber.replace(/\s+/g, "");
      this.adminService.findBulletinByNumberMake(bulletinId, makeSelected).subscribe(
        bulletinData => {

          this.relatedSIBs.push(bulletinNumber);
        },
        error => {
          // alert('Please enter valid SIB bulletin.');
          console.error('Error searching bullletin by numbermake', error);
          this.errorMessageSIB = 'Please enter valid active SIB.';
          //this.errorMessage = error.error.message;
        });
    }
  }

  removeFromSelection(listType: string, listItem: string) {
    switch (listType) {
      case 'sib':
        this.relatedSIBs = this.relatedSIBs.filter(item => item !== listItem);
        break;
    }
  }
  removeFromNoiseSelection(listType: any, listItem: any) {
    switch (listType) {

      case 'series':
        this.seriesFilterList = this.seriesFilterList.filter(item => item !== listItem.seriesName);
        break;
      case 'area':
        this.areaFilterList = this.areaFilterList.filter(item => item !== listItem);
        break;
      case 'component':
        this.componentFilterList = this.componentFilterList.filter(item => item !== listItem);
        break;
      case 'drivingCondition':
        this.drivingConditionFilterList = this.drivingConditionFilterList.filter(item => item !== listItem);
        break;
      case 'weatherCondition':
        this.weatherConditionFilterList = this.weatherConditionFilterList.filter(item => item !== listItem);
        break;
      case 'kindOfNoise':
        this.kindOfNoiseFilterList = this.kindOfNoiseFilterList.filter(item => item !== listItem);
        break;
    }
  }

  public addToNoiseSelection(listType: string, listItem: any): void {
    // FIXME method being used with no implementation
  }

  fileUpload(fileObj) {
    if (fileObj && fileObj.target.files.length > 0) {
      const file = fileObj.target.files[0];
      const isFileValid = this.utilityService.fileValidator(file.name);
      if (!isFileValid) {
        this.errorMessage = 'File type not supported';
        this.uploadedFile = null;
        this.uploadedFileName = '';
      } else {
        this.errorMessage = '';
        this.uploadedFile = file;
        this.uploadedFileName = file.name;
        this.newUploadFlag = true;
      }
    }
  }

  onSubmit(form: NgForm) {
    if (form.valid) {
      this.submit(form);
    }
  }

  submit(form: NgForm) {
    // this.inputDate = (this.inputDate) ? this.inputDate['formatted'] : this.setDefaultDate();
    if (this.inputDate == null) {
      this.inputDate = this.setDefaultDate();
    }
    if (this.setDateFlag === true && this.inputDate['formatted'] == null) {
      // no action
    } else if (this.inputDate['formatted'] == null && this.setDateFlag === false) {
      this.inputDate = this.setDefaultDate();
    } else {
      this.inputDate = this.inputDate['formatted'];
      this.setDateFlag = true;
    }

    //Trilok Start
    if (this.actionType === 'edit') {
      // this.spinnerService.show("bmwSpinner");
      if (this.bulletinType === 'noise catalog') {
        const selectedSeries = filterSeriesArray(this.seriesList, this.seriesFilterList);
        const selectedMake = this.makeList.find(make => make['makeName'] === this.inputMake);
        const noiseObject = {
          "noiseCatalogDisplayId": this.noiseCatalogData.noiseCatalogDisplayId,
          "noiseCatalogDisplayNumber": this.noiseCatalogData.noiseCatalogDisplayNumber,
          "noiseCatalogId": this.noiseCatalogData.noiseCatalogId,
          "noiseCatalogTitle": this.textareaContent,
          "bulletinDisplayNumber": this.relatedSIBs,
          "make": selectedMake,
          "mainGroup": this.inputChannel,
          "releaseDate": this.inputDate,
          "createdTs": this.noiseCatalogData.createdTs,
          "updatedTs": this.setDefaultDate(),
          "series": selectedSeries,
          "noiseCatalogAreas": this.areaFilterList,
          "noiseCatalogComponents": this.componentFilterList,
          "noiseDrivingConditions": this.drivingConditionFilterList,
          "noiseWeatherConditions": this.weatherConditionFilterList,
          "noiseNoiseTypes": this.kindOfNoiseFilterList,
          "sporadicOrPermanent": this.inputSproadicPermanent,
          "noiseCatalogVimeoId": this.vimeoID,
          "likes": this.noiseCatalogData.likes,
          "dislikes": this.noiseCatalogData.dislikes,
          "views": this.noiseCatalogData.views,
        };
        this.spinnerService.show("bmwSpinner");
        this.subscriptions.push(this.adminService.updateNoiseCatalog(noiseObject).subscribe(value => {
          if (value) {
            // this.documentNumbersList = [];
            //if (this.reactivateOrDeactivate === 'reactivate') {
            if (this.reactivate === true) {
              this.subscriptions.push(this.adminService.updateNoiseCatalogActiveStatus(this.noiseCatalogData.noiseCatalogDisplayId, this.userEmail, selectedMake.makeName, true)
                .subscribe(data => {
                  this.toastService.popToast('NoiseCatalog Reactivated');
                  this.spinnerService.hide("bmwSpinner");
                },
                  // error => {
                  //   this.spinnerService.hide("bmwSpinner");
                  //   this.errorMessage = error.error.message;
                  // }));
                  error => {
                    this.spinnerService.hide("bmwSpinner");
                    console.error('Error updating noise catalog status', error);
                    //this.errorMessage = error.error.message;
                    if (error.error.status !== null && error.error.status.statusCode === 'FAILURE') {
                      this.errorMessage = error.error.status.errorDetails;
                    }
                  }));
            }
            //else if (this.reactivateOrDeactivate === 'deactivate') {
            else if (this.deactivate === true) {
              this.subscriptions.push(this.adminService.updateNoiseCatalogActiveStatus(this.noiseCatalogData.noiseCatalogDisplayId, this.userEmail, selectedMake.makeName, false)
                .subscribe(data => {
                  this.toastService.popToast('NoiseCatalog Deactivated');
                  this.spinnerService.hide("bmwSpinner");

                },
                  // error => {
                  //   this.spinnerService.hide("bmwSpinner");
                  //   this.errorMessage = error.error.message;
                  // }));
                  error => {
                    this.spinnerService.hide("bmwSpinner");
                    console.error('Error updating noise catalog status');
                    //this.errorMessage = error.error.message;
                    if (error.error.status !== null && error.error.status.statusCode === 'FAILURE') {
                      this.errorMessage = error.error.status.errorDetails;
                    }
                  }));
            }

            this.spinnerService.hide("bmwSpinner");
            this.resetFields();

            this.toastService.popToast('NoiseCatalog Updated');
            this.inputChannel = null;
            this.uploadedFile = null;

            this.errorMessage = '';
            this.errorMessageSIB = '';
            this.inputSeries = '';
            this.inputArea = '';
            this.inputComponent = '';
            this.inputDrivingCondition = '';
            this.inputWeatherCondition = '';
            this.inputKindOfNoise = '';


            this.errorMessage = '';
            // this.reactivateOrDeactivate = null;
            this.reactivate = false;
            this.deactivate = false;
            this.showAllFields = false;
            //form.resetForm(); // or form.reset();
            //form.reset();
            // form.resetForm();
            this.inputSproadicPermanent = "undefined";
            this.inputChannel = "undefined";
            this.noiseCatalogNumber = "undefined";
            this.makeSelected = "undefined";
            this.prevMake = "undefined";

          }
        }));
      }
    }
    ///Trilok End

    this.analyticCallNoiseCatalogUpdated();
  }
  analyticCallNoiseCatalogUpdated() {
    let userID = this.authService.getUserName();
    this.analyticsService.trackEditContentUpdated(userID, "Noise Catalog", this.makeSelected, this.noiseCatalogNumber, 'updated');
  }

  public setReactivate(event: any): void {
    // FIXME method being used with no implementation
  }

  public setDeactivate(event: any): void {
    // FIXME method being used with no implementation
  }
  setRandomDocNumber() {
    if (this.bulletinType == "obd") {
      this.documentNumber = "OD" + Math.floor(100000 + Math.random() * 900000);
      return this.documentNumber;
    } else {
      return '';
    }
  }

  formatBulletinNumber(event: any, sibOrVideo: string) {
    if (event.key == "ArrowLeft" || event.key == "ArrowRight" || event.keyCode == 8 || event.keyCode == 65 || event.keyCode == 67 || event.keyCode == 17) { return };
    let tempInput;
    let split = 2;
    let chunk = [];
    // tempInput = tempInput.replace(/[\D\s\._\-]+/g, "");

    if (sibOrVideo === 'sib') {
      tempInput = this.bulletinNumber;
      tempInput = tempInput.replace(/[\D\s\._\-]+/g, "");
      for (let i = 0; i < this.bulletinNumber.length; i += split) {
        chunk.push(tempInput.substr(i, split));
      }
      tempInput = chunk.join(' ').trim();
      this.bulletinNumber = tempInput.slice(0, 8);
    }
    else if (sibOrVideo === 'noise catalog') {
      tempInput = this.documentNumber;
      tempInput = tempInput.replace(/[\D\s\._\-]+/g, "");
      for (let i = 0; i < this.documentNumber.length; i += split) {
        chunk.push(tempInput.substr(i, split));
      }
      tempInput = chunk.join(' ').trim();
      this.documentNumber = tempInput.slice(0, 8);
    }
  }

  setDefaultDate(): string {
    let d = new Date();
    let month = '' + (d.getMonth() + 1);
    let day = '' + d.getDate();
    let year = d.getFullYear();
    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;
    return [year, month, day].join('-');
  }

  ngOnDestroy(): void {
    this.subscriptions.map(s => s.unsubscribe());
  }

  private handleBrandChange() {
    let make: string;

    if (typeof this.inputMake === 'object') {
      make = this.inputMake['makeName'];
    } else {
      make = this.inputMake;
    }

    if (make === 'BMW' || make === 'MINI') {
      this.showTakata = true;
    } else if (make === 'MOTORRAD' || make === 'ROLLSROYCE') {
      this.showTakata = false;
    } else {
      this.showTakata = true;
    }
  }
}

function filterSeriesArray(array, filter) {
  var myArrayFiltered = [];
  for (var i = 0; i < array.length; i++) {
    for (var j = 0; j < filter.length; j++) {
      if (array[i].id === filter[j].id && array[i].seriesName === filter[j].seriesName) {
        myArrayFiltered.push(array[i]);
      }
    }
  }
  return myArrayFiltered;
}